<span class="tt-o-badge" :class="typeClass"><slot/></span>